import '../App.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VirtualTablet from '../VirtualTablet';
import axios from 'axios';
import Totem2 from '../Totem2';
import TotemStanding from '../TotemStanding';
import V2Card from '../V2Card';

function CampaignAdCreative({ campaign, patchCampaign }) {
    const navigate = useNavigate();

    const [campaignPreview, setCampaignPreview] = useState(null);

    function loadCampaignPreview() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/campaign/preview/?campaign_id=${campaign.id}`,
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            },
        ).then(
            (response) => {
                if (response.data.url) {
                    setCampaignPreview(response.data.url);
                }
            }
        ).catch(
            (error) => {
                navigate('/');
            }
        )
    }

    useEffect(
        () => {
            loadCampaignPreview();
        },
        [],
    )

    return (
        <V2Card>
            <div style={{ marginBottom: '1em' }}>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                    }}
                >
                    <Totem2
                        creativeURL={campaign.creative_url}
                        creativeExt={campaign.creative_ext}
                    />
                    <TotemStanding
                        creativeURL={campaign.creative_url}
                        creativeExt={campaign.creative_ext}
                    />
                    <VirtualTablet
                        campaign={campaign}
                        height={15}
                        width={10}
                    />
                    <VirtualTablet
                        campaign={campaign}
                        height={20}
                        width={10}
                    />
                    <VirtualTablet
                        campaign={campaign}
                        height={10}
                        width={20}
                    />
                    <VirtualTablet
                        campaign={campaign}
                        height={10}
                        width={15}
                    />
                    {
                        campaignPreview &&
                        <div style={{ margin: '1em' }}>
                            <div style={{ width: '20em' }}>
                                <img
                                    src={campaignPreview} width='100%'
                                    className='campaign-preview'
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </V2Card>
    );
}

export default CampaignAdCreative;